<template>
  <q-inner-loading
    :showing="true"
    class="flex items-center justify-center size-full z-50"
    :style="{ 'font-size': size }"
  >
    <div class="flex gap-8 items-center flex-col">
      <q-spinner-puff color="primary-pure" />
      <p v-if="percent" class="text-paragraph-2 !font-medium">
        {{ percent }}%
      </p>
    </div>
  </q-inner-loading>
</template>

<script setup>
const props = defineProps({
  size: {
    type: String,
    default: '3rem',
  },
  percent: Number,
})
</script>
